export const IconDotsVertical = ({ className = '' }) => (
  <svg className={className} focusable="false" aria-hidden="true" viewBox="0 0 24 24" tabIndex={-1}>
    <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"></path>
  </svg>
);
